import { breakpoints } from '@configs/breakpoints';
import { colors, Loader, px2rem, Tabs, TabsProps } from '@fortum/elemental-ui';
import styled from 'styled-components';

export const MainContainer = styled.div`
  --max-content-width: ${px2rem(1280)};

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 70vh;
  position: relative;
`;

export const AppHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const NavigationTabsContainer = styled.div`
  border-bottom: 1px solid ${colors.silverGrey};
  box-sizing: border-box;
  background-color: ${colors.snowWhite};

  @media screen and (max-width: ${breakpoints.large}) {
    border-bottom: 0px;
  }
`;

export const PositionedLoaderContainer = styled.div`
  min-height: ${px2rem(800)};
`;

export const StyledTabs = styled(Tabs)<TabsProps>`
  max-width: var(--max-content-width);
  margin: 0 auto;
`;

export const PositionedLoader = styled(Loader)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
`;

export const StyledMain = styled.main`
  outline: none;

  &:focus {
    outline: 2px solid ${colors.broadBlue700};
    outline-offset: ${px2rem(4)};
  }
`;
